/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPinDto } from '../../models/user-pin-dto';

export interface GetMyUserPin$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getMyUserPin(http: HttpClient, rootUrl: string, params: GetMyUserPin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPinDto>> {
  const rb = new RequestBuilder(rootUrl, getMyUserPin.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserPinDto>;
    })
  );
}

getMyUserPin.PATH = '/api/user-pins/my/{id}';
